/* Selector de la opcion "Luz" compuesta ("Tono · Modalidad") de las fichas
   EXPRESS. Ver snippets/luz-composite-picker.liquid.
   Delegacion en document porque product-info reemplaza <variant-selects>
   entero tras cada cambio de variante. Cada clic se traduce en un "change"
   sobre el radio oculto de Shopify que corresponde a la combinacion elegida.
   Reglas:
     - Bi-LED solo existe en las modalidades con touch para la luz; al elegir
       Bi-LED se pasa a la modalidad equivalente con touch (con antivaho ->
       doble touch; sin antivaho -> touch luz).
     - Al pulsar una modalidad que no existe para Bi-LED se vuelve al ultimo
       tono fijo elegido (o al primero). */
(function () {
  if (window.__luzCompositeInit) return;
  window.__luzCompositeInit = true;

  var SEP = ' · ';
  var lastSingleTone = null;

  function split(value) {
    var i = value.indexOf(SEP);
    return i < 0 ? [value, ''] : [value.slice(0, i), value.slice(i + SEP.length)];
  }

  function radios(root) {
    return Array.prototype.slice.call(root.querySelectorAll('.luz-composite__inputs input[type=radio]'));
  }

  function enabled(radio) {
    return !!radio && !radio.classList.contains('disabled');
  }

  function findRadio(root, value) {
    return radios(root).filter(function (r) { return r.value === value; })[0] || null;
  }

  function select(radio) {
    if (!radio || radio.checked) return;
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function state(root) {
    return {
      tone: root.getAttribute('data-luz-sel-tone') || '',
      mod: root.getAttribute('data-luz-sel-mod') || '',
      biled: root.getAttribute('data-luz-biled-tone') || ''
    };
  }

  function firstSingleTone(root) {
    var st = state(root);
    var list = radios(root).map(function (r) { return split(r.value)[0]; })
      .filter(function (t) { return t && t !== st.biled; });
    return list[0] || '';
  }

  /* Radio para tono + modalidad; si no existe, la modalidad mas parecida de
     ese tono (misma presencia de antivaho) o la primera disponible. */
  function pick(root, tone, mod) {
    var exact = findRadio(root, tone + SEP + mod);
    if (enabled(exact)) return exact;
    var list = radios(root).filter(function (r) { return split(r.value)[0] === tone && enabled(r); });
    if (!list.length) return null;
    var wantAntivaho = /antivaho/i.test(mod);
    var alike = list.filter(function (r) { return /antivaho/i.test(split(r.value)[1]) === wantAntivaho; });
    return alike[0] || list[0];
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-luz-type], [data-luz-tone], [data-luz-mod]');
    if (!btn) return;
    var root = btn.closest('[data-luz-composite]');
    if (!root) return;
    event.preventDefault();

    var st = state(root);
    if (st.tone && st.tone !== st.biled) lastSingleTone = st.tone;
    var tone = st.tone;
    var mod = st.mod;

    if (btn.hasAttribute('data-luz-type')) {
      tone = btn.getAttribute('data-luz-type') === 'biled' ? st.biled : (lastSingleTone || firstSingleTone(root));
    } else if (btn.hasAttribute('data-luz-mod')) {
      mod = btn.getAttribute('data-luz-mod');
      if (!enabled(findRadio(root, tone + SEP + mod))) {
        tone = lastSingleTone || firstSingleTone(root);
      }
    } else {
      tone = btn.getAttribute('data-luz-tone');
    }

    select(pick(root, tone, mod));
  });
})();
